import React, { Component } from 'react'
import { SearchBarTable } from 'hljd'
import getColumns from './columns'
import { observer, inject } from 'mobx-react'

@inject('store')
@observer
export default class extends Component {
  render() {
    return (
      <SearchBarTable
        bordered
        columns={getColumns(this.props.store)}
        store={this.props.store}
        style={{ marginTop: 20 }}
      />
    )
  }
}
